/* eslint no-unused-vars: 0 */
export function formatDate(d) {
  // get the month
  let month = d.getMonth();
  // get the day
  // convert day to string
  const day = d.getDate().toString();
  // get the year
  let year = d.getFullYear();

  // pull the last two digits of the year
  year = year.toString().substr(-2);

  // increment month by 1 since it is 0 indexed
  // converts month to a string
  month = (month + 1).toString();

  // if month is 1-9 pad right with a 0 for two digits
  if (month.length === 1) {
    month = `0${month}`;
  }

  // if day is between 1-9 pad right with a 0 for two digits
  // if (day.length === 1)
  // {
  //     day = "0" + day;
  // }

  // return the string "MMddyy"
  return `${month}/${day}/${year}`;
}

export function setTimeZone(date) {
  const dateTzOffSet = date ? new Date(date) : new Date();

  dateTzOffSet.setTime(dateTzOffSet.getTime() + dateTzOffSet.getTimezoneOffset() * 60 * 1000);

  return dateTzOffSet;
}

export function formatBirthdayForServer(d) {
  // get the month
  let month = d.getMonth();
  // get the day
  // convert day to string
  let day = d.getDate().toString();
  // get the year
  const year = d.getFullYear();

  // increment month by 1 since it is 0 indexed
  // converts month to a string
  month = (month + 1).toString();

  // if month is 1-9 pad right with a 0 for two digits
  if (month.length === 1) {
    month = `0${month}`;
  }

  if (day.length === 1) {
    day = `0${day}`;
  }

  return `${year}-${month}-${day}`;
}

export function formatBirthday(d) {
  // get the month
  let month = d.getMonth();
  // get the day
  // convert day to string
  let day = d.getDate().toString();
  // get the year
  const year = d.getFullYear();

  // increment month by 1 since it is 0 indexed
  // converts month to a string
  month = (month + 1).toString();

  // if month is 1-9 pad right with a 0 for two digits
  if (month.length === 1) {
    month = `0${month}`;
  }

  if (day.length === 1) {
    day = `0${day}`;
  }

  return `${month}.${day}.${year}`;
}

export function formatDateMmDdHHmm(d) {
  // get the month
  let month = d.getMonth();
  // get the day
  // convert day to string
  const day = d.getDate().toString();
  // get the year
  let year = d.getFullYear();

  // pull the last two digits of the year
  year = year.toString().substr(-2);

  // increment month by 1 since it is 0 indexed
  // converts month to a string
  month = (month + 1).toString();

  // if month is 1-9 pad right with a 0 for two digits
  if (month.length === 1) {
    month = `0${month}`;
  }

  const time = d.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

  return {
    date: `${month}/${day}`,
    time: time.substring(0, time.length - 2).trim(),
    hour12: time.substr(-2)
  };
}

export const getDateWithStartOfDayInUTCStringify = (date) => {
  date.setHours(0, 0, 0, 0);
  return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toJSON();
};

export const toISO8601 = (inputDate) => {
  const timezoneOffset = inputDate.getTimezoneOffset();

  const offsetHours = parseInt(Math.abs(timezoneOffset / 60));
  const offsetMinutes = Math.abs(timezoneOffset % 60);

  const leftFill = (inputNumber, targetLength = 2) => {
    return inputNumber.toString().padStart(targetLength, '0');
  }

  let formattedTimezone;

  if (timezoneOffset < 0) {
    formattedTimezone = '+' + leftFill(offsetHours) + ':' + leftFill(offsetMinutes);
  }
  else if (timezoneOffset > 0) {
    formattedTimezone = '-' + leftFill(offsetHours) + ':' + leftFill(offsetMinutes);
  }
  else if (timezoneOffset == 0) {
    formattedTimezone = 'Z';
  }

  const formattedDateTime =
    inputDate.getFullYear() +
    '-' +
    leftFill(inputDate.getMonth() + 1) +
    '-' +
    leftFill(inputDate.getDate()) +
    'T' +
    leftFill(inputDate.getHours()) +
    ':' +
    leftFill(inputDate.getMinutes()) +
    ':' +
    leftFill(inputDate.getSeconds()) + 
    '.' +
    inputDate.getMilliseconds().toString().padEnd(7, '0');

  return formattedDateTime + formattedTimezone;
};



// WEBPACK FOOTER //
// ./src/helpers/date.js